import { render, staticRenderFns } from "./PixRefundModal.vue?vue&type=template&id=03b5780c"
import script from "./PixRefundModal.vue?vue&type=script&lang=js"
export * from "./PixRefundModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports